
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'cnpj',
        label: 'CNPJ',
        mask:'cnpj',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'select-cnae',
        field: 'cnae',
        label: 'CNAE',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'ie',
        label: 'Inscrição Estadual',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'cep',
        field: 'cep',
        label: 'CEP',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'end',
        label: 'Endereço',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'num',
        label: 'Número',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'comp',
        label: 'Complemento',
        info: '',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'select-uf',
        field: 'id_estado',
        label: 'Estado',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3',
        type: 'select-cidade',
        field: 'id_cidade',
        label: 'Cidade',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'text',
        field: 'bairro',
        label: 'Bairro',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'tel_com',
        label: 'Telefone',
        mask:'telefone',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2',
        type: 'text',
        field: 'tel_cel',
        label: 'Celular',
        mask: 'celular',
        info: '',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-8',
        type: 'email',
        field: 'email',
        label: 'Email',
        info: '',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-6',
        type: 'text',
        field: 'site',
        label: 'Site',
        info: '',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'resp',
        label: 'Responsável',
        info: '',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'r_obs',
        label: 'Observações',
        info: '',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/laboratorio/_form/parceiro-cadastrar.js